import { useMemo, useState } from "react";
import Button from "../ui/Button";
import Input from "../ui/Input";
import Select from "../ui/Select";
import { useCashierText } from "./cashierText";

const emptyForm = { type: "", reason: "", note: "" };

export default function OutcomeSheet({
  order,
  onClose,
  onSaveOutcome,
  busy,
}) {
  const [form, setForm] = useState(emptyForm);
  const [error, setError] = useState("");
  const [adding, setAdding] = useState(false);
  const { t, conclusionOptions: options } = useCashierText();
  const selected = useMemo(
    () => options.find((item) => item.value === form.type),
    [options, form.type],
  );
  const conclusions = order.conclusions || [];
  const active = conclusions.filter((item) => !item.revertedAt);
  const activeTypes = new Set(active.map((item) => item.type));
  const availableOptions = options.filter(
    (item) => !activeTypes.has(item.value),
  );
  const conclusionOptions = availableOptions.map((item) => ({
    label: item.label,
    value: item.value,
  }));
  const reasonOptions =
    selected?.reasons?.map((item) => ({
      label: item.label,
      value: item.value,
    })) || [];
  const set = (key, value) =>
    setForm((old) => ({
      ...old,
      [key]: value,
      ...(key === "type" ? { reason: "" } : {}),
    }));
  const submit = async (event) => {
    event.preventDefault();
    const note = form.note.trim();
    if (!form.type && !note) return setError(t.chooseConclusionOrNote);
    if (selected?.reasons?.length && !form.reason)
      return setError(t.chooseConclusionReason);
    setAdding(true);
    setError("");
    try {
      await onSaveOutcome({
        conclusion: form.type
          ? {
              type: form.type,
              reason: selected?.reasons?.length ? form.reason : null,
            }
          : null,
        note: note || null,
      });
      setForm(emptyForm);
    } catch (e) {
      setError(e.message);
    } finally {
      setAdding(false);
    }
  };
  return (
    <div className="cashier-modal">
      <form className="cashier-sheet outcome-sheet" onSubmit={submit}>
        <h3>{t.outcomeTitle(order.last4)}</h3>
        <section className="cashier-add-conclusion">
          <div className="cashier-section-title">
            <b>{t.addConclusionOrNote}</b>
          </div>
          <Select
            label={t.conclusion}
            value={form.type}
            onChange={(e) => set("type", e.target.value)}
            placeholder={t.noConclusion}
            options={conclusionOptions}
          />
          {!availableOptions.length && (
            <p className="cashier-empty">
              {t.allConclusionsAdded}
            </p>
          )}
          {selected?.reasons?.length > 0 && (
            <Select
              label={t.reason}
              value={form.reason}
              onChange={(e) => set("reason", e.target.value)}
              placeholder={t.chooseReason}
              options={reasonOptions}
            />
          )}
          <Input
            label={t.note}
            textarea
            value={form.note}
            onChange={(e) => set("note", e.target.value)}
            maxLength="5000"
            placeholder={t.optional}
          />
        </section>
        {error && <div className="cashier-notice">{error}</div>}
        <div className="cashier-sheet-actions">
          <Button type="button" variant="neutral" onClick={onClose}>
            {t.close}
          </Button>
          <Button type="submit" appearance="filled" disabled={busy || adding}>
            {adding ? t.saving : t.save}
          </Button>
        </div>
      </form>
    </div>
  );
}
